$("#truck-modal").click(function () {$("#truck-comtainer-modal").css({"display": "block"})});
$("#truck-modal-mobile").click(function () {$("#truck-comtainer-modal").css({"display": "block"})});
$(".truck-icon-item").click(function () {$("#truck-comtainer-modal").css({"display": "none"})});

// Resize con debounce para no re-ejecutar generarSliders en cada frame
var _slidersResizeTimer;
$(window).resize(function(){
  clearTimeout(_slidersResizeTimer);
  _slidersResizeTimer = setTimeout(generarSliders, 150);
});
$(function(){
    generarSliders()
})



function generarSliders(){
    widthWindow = document.documentElement.clientWidth;
    // Nota perf: se eliminó el hack $("#slidershow-container").height(width).
    // La altura del banner ahora la da el aspect-ratio intrínseco (width/height reales en sliderShow.liquid).
    if (widthWindow <= 520) {

        /** */
        try {
            $('.lista-imagenes').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                settings: {
                    arrows: true,
                }
            });

            $('.slider-mobile').slick({
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                settings: {
                    arrows: true,
                }
            });
            $('.promo-slider').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                settings: {
                    arrows: true,
                }
            });
            $('.tr-slider').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                settings: {
                    arrows: true,
                }
            });
            $.each($(".lista-iconos"), function (index, key) {

                let itemsRow = $(this).attr("data-items")


                $(this).slick({
                    infinite: true,
                    autoplay: true,
                    slidesToShow: itemsRow,
                    slidesToScroll: 1,
                    settings: {
                        arrows: true,
                    }
                });
            })
        } catch (error) {
            setTimeout(() => {

            }, 100);
        }
        $.each($(".cambioImagenMobile"), function (index, key) {

            let imgMobile = $(this).attr("data-bgmobile");
            $(this).css("background-image",'url("'+ imgMobile+' ")')
        })
        /**/
    } else {
        try {

            $('.lista-imagenes,.slider-mobile,.promo-slider,.lista-iconos').slick('unslick');
        } catch (error) {

        }
    }
}

setTimeout(function () {
    $("button[class='flickity-button flickity-prev-next-button next']").append("<img alt='Next' src='//bebesit.cl/cdn/shop/t/173/assets/Copy%20of%20WFLECHAI.png?v=130242628817836378511780274437' >");
    $("button[class='flickity-button flickity-prev-next-button previous']").append("<img alt='Previous' src='//bebesit.cl/cdn/shop/t/173/assets/Copy%20of%20WFLECHAD.png?v=79995401687084863011780274437' >");
},500)


$(".site-header-button.site-header-menu-button").on("click",function(){
    $(".site-mobile-nav").addClass("visible");

})

$(".close-icon-burger").on("click",function(){
  $(".site-mobile-nav").removeClass("visible");
  $(".template-index").removeClass("scroll-lock");
})

// Fix (sep-2026): la galeria de la PDP a veces queda con un alto fijo chico (~32px) porque
// _setSlideHeight() de superstore.js mide la figura antes de que baje la imagen principal.
// Red de seguridad: al cargar cada imagen del viewer (y en window.load / 1,5 s) se vuelve a
// medir la figura seleccionada y, solo si el alto quedo mal, se corrige. No toca el cambio
// de slide ni el zoom (solo actua si la diferencia es > 2px y la figura mide > 50px).
(function () {
  function fixViewer(viewer) {
    var fig = viewer.querySelector('[data-gallery-selected="true"]');
    if (!fig) return;
    var h = fig.getBoundingClientRect().height;
    if (h > 50 && Math.abs(viewer.getBoundingClientRect().height - h) > 2) {
      viewer.style.height = h + 'px';
    }
  }
  function init() {
    document.querySelectorAll('.product-gallery--viewer').forEach(function (viewer) {
      var run = function () { fixViewer(viewer); };
      viewer.querySelectorAll('img').forEach(function (img) {
        if (img.complete) run(); else img.addEventListener('load', run, { once: true });
      });
      window.addEventListener('load', run);
      setTimeout(run, 1500);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
